import styled from "styled-components";

export const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 1rem;

  @media (max-width: 64rem) {
    flex-direction: column;
    align-items: start;
  }
`;

export const FormWrapper = styled.div`
  flex: 1;
  max-width: 31.25rem;
`;

export const ImageWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  @media (max-width: 64rem) {
    display: none;
  }
`;

export const FeedbackImage = styled.img`
  max-width: 100%;
  height: auto;
`;

export const ErrorText = styled.span`
  color: red;
  font-size: 0.875rem;
  display: block;
  margin-top: 5px;
`;
